/* eslint-disable @typescript-eslint/no-unused-vars */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
import React from 'react'
import { Form, Select } from 'antd'
import { SelectValue } from 'antd/lib/select'
import { FORM_SELECT_MODE_PROPS, LABEL_ALIGN_TYPE } from '../form.constants'
import { formRules } from '../form.utils'
import classNames from 'classnames'
import '../form.scss'
import '../floating-label/floatingLabel.scss'
import { CaretDownOutlined } from '@ant-design/icons'
import InfoToolTipLabel from '../infotooltip-label/infotooltip-label'

export interface OptionProp {
  key?: number | string
  name: string
  value: number | string
  dataName?: any
}

export interface InputSelectProps {
  label: string
  name: string
  isRequired?: boolean
  isDisabled?: boolean
  onChange?: (value: SelectValue) => void
  options: OptionProp[] | []
  className?: string
  inputContainerStyle?: string
  labelAlign?: keyof typeof LABEL_ALIGN_TYPE
  validateTrigger?: string | string[]
  validator?: () => void
  mode?: keyof typeof FORM_SELECT_MODE_PROPS
  showArrow?: boolean
  allowClear?: boolean
  defaultValue?: string
  labelInValue?: boolean
  placeholder?: string
  onDropdownVisibleChange?: (visible: boolean) => void
  htmlLabel?: string
  forwardedRef?: any
  autoFocus?: boolean
  excludeNoPreference?: boolean
  search?: boolean
  getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement
  placement?: 'bottomLeft' | 'bottomRight' | 'topLeft' | 'topRight'
}

export const fromSelectOptions = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any,
  nameKey: string,
  valueKey: string,
  dataName?: string
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return data
    ? data.map((item: any) => {
        return {
          name: item[nameKey],
          value: item[valueKey],
          dataName: dataName ? item[dataName] : undefined,
        }
      })
    : []
}

const InputSelect: React.FC<InputSelectProps> = (props: InputSelectProps) => {
  const {
    label,
    htmlLabel,
    name,
    onChange,
    options,
    isRequired,
    isDisabled,
    className,
    validator,
    validateTrigger,
    labelAlign,
    mode,
    showArrow = true,
    allowClear = false,
    defaultValue,
    labelInValue,
    inputContainerStyle,
    onDropdownVisibleChange,
    forwardedRef,
    autoFocus = false,
    excludeNoPreference,
    search,
    getPopupContainer,
    placement = 'bottomLeft',
  } = props
  const { Option } = Select

  const FormOptionsList = (options: OptionProp[]) => {
    return options.map((option: OptionProp) => {
      if (excludeNoPreference && option.value == 'No Preference') {
        return null
      }
      if (option.dataName != undefined) {
        return (
          <Option value={option.value} key={`${option.name}  ${option.value}`}>
            {option.name}, {option.dataName.name}
          </Option>
        )
      }
      return (
        <Option value={option.value} key={`${option.name}  ${option.value}`}>
          {option.name}
        </Option>
      )
    })
  }
  return (
    <>
      <label htmlFor={htmlLabel ? htmlLabel : label}>
        <InfoToolTipLabel label={label} />
      </label>
      <Form.Item
        label={label}
        name={name}
        validateTrigger={validateTrigger}
        labelAlign={labelAlign}
        rules={formRules(label, isRequired, validator)}
        className={classNames('block', className, 'input-select')}
        validateFirst={true}
      >
        <Select
          aria-label={label}
          suffixIcon={<CaretDownOutlined />}
          labelInValue={labelInValue}
          className={classNames('form-item-input-width', inputContainerStyle)}
          onChange={onChange}
          id={name}
          mode={mode}
          onDropdownVisibleChange={onDropdownVisibleChange}
          maxTagCount={3}
          showArrow={showArrow}
          allowClear={allowClear}
          defaultValue={defaultValue}
          disabled={isDisabled}
          optionFilterProp="children"
          ref={forwardedRef}
          autoFocus={autoFocus}
          showSearch={search}
          getPopupContainer={getPopupContainer || ((triggerNode) => triggerNode.parentNode)}
          placement={placement}
        >
          {FormOptionsList(options)}
        </Select>
      </Form.Item>
    </>
  )
}

export default InputSelect